import styled from 'styled-components'

export const ContainerCheckbox = styled.div`
  width: 25%;
  & label { margin-top: 0; margin-bottom: 0; }
  & > div {
    margin-top: 0;
  }
  & > div {
    &:last-child {
      & > div {
        display: flex;
        justify-content: space-between;
      }
      & > div > div { width: auto;margin: 0 .5rem; }
    }
  }
`;

export const ContainerRadio = styled.div`
  width: 33.333%;
  padding-right: 15px;
  & label { margin-top: 0; margin-bottom: 0; }
  & > div {
    margin-top: 0;
    &:last-child {
      & > div {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 8px 16px;
      }
      & > div > div { width: auto;margin: 0 .5rem; }
    }
  }
  &:last-child {
    padding: 0;
  }
  & label { 
    &::before { content: none !important; }
  }
`;
